import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useFetch from 'use-http';
import { Grid, Typography } from '@mui/material';
import Message from './messages/Message';
import CommandeRecap from './CommandeRecap';
import CardUniteTravail from './cards/CardUniteTravail';
import { useCommandeContext, changeValeur } from "../contexts/CommandeContext";
import ServiceProduit from '../services/ServiceProduit';
import Cookies from 'js-cookie';
import CardOptionUniteTravail from './cards/CardOptionUniteTravail';
import GenericText from './forms/GenericText';

export default function EtapeProduitDetails({ props }) {

	// Recupération du dispatcher à partir du CommandeContext
	const { commande, dispatch } = useCommandeContext();

	// Initialisation de l'accés au backend
	const { get } = useFetch(process.env.REACT_APP_BACKEND_API_URL);
	const [produitDb, setProduitDb] = useState(null);

	let { prestationKey, produitKey } = useParams();

	// Chargement des données du produit
	let produit = ServiceProduit.getProduit(prestationKey, produitKey);

	useEffect(() => {

		async function handleLoadProduit(key) {
			setProduitDb(await get('/produit?key=' + key));
		}
		handleLoadProduit(produitKey);

		Cookies.remove("commandeDetails");
		Cookies.remove("commandeCreneau");
		Cookies.remove("commandeCommune");

	}, [produitKey, get]);

	useEffect(() => {

		if (produitDb) {

			// Initialisation du produit dans le context
			if (commande.produit === undefined || (commande.produit && produitDb.id !== commande.produit.id)) {

				dispatch(changeValeur('produit', produitDb));


				// Initialisation des valeurs par défaut des unites de travail			
				produitDb.unitesTravail.forEach((ut) => {
					if (ut.quantiteMin > 0 && commande[ut.workUnitKey] === undefined) {
						dispatch(changeValeur(ut.workUnitKey, ut.quantiteMin));
					}
				});
			}
		}

	}, [produitDb, dispatch, commande]);

	return (
		<>
			<Grid container direction="row" justifyContent="center" align="center" spacing={2}>

				<Grid item xs={12}>
					<Typography component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
						Les détails de mon intervention
					</Typography>
				</Grid>

				{(produit.commande.texteInfo !== undefined && produit.commande.texteInfo !== '') &&
					<Message props={{ type: 'info', message: produit.commande.texteInfo }} />
				}

				{
					// Boucle sur la liste des unites de travail
					produitDb ? produitDb.unitesTravail.map(function(d, index) {
						return (
							<Grid key={index} item xs={6} sm={6} md={3} sx={{ pb: 2 }}>
								<CardUniteTravail uniteTravail={d} val={commande[d.workUnitKey]} />
							</Grid>
						)
					}) : ''
				}

				{
					// Affichage des questions complémentaires pour le produit dépannage
					produitDb && produitDb.displayInfosCompl &&

					<Grid item xs={12} sm={12} md={6}>


						<Grid container px={2} direction="row" justifyContent="center" align="center" spacing={1}>
						
						<Grid item xs={12}>
							<Message props={{ type: 'info', message: 'Renseignez la <b>Marque</b>, le <b>Modèle</b> et la <b>Description du problème</b> afin de nous aider à vous dépanner plus rapidement' }} />
						</Grid>

						<Grid item xs={12}>
							<GenericText
								id="equipementMarque"
								name="equipementMarque"
								label="Marque" />
						</Grid>
						<Grid item xs={12}>
							<GenericText
								id="equipementModele"
								name="equipementModele"
								label="Modèle" />
						</Grid>
						<Grid item xs={12}>
							<GenericText
								id="problemeDescription"
								name="problemeDescription"
								label="Description du problème"
								multiline
								rows={4} />
						</Grid>
						</Grid>
					</Grid>
				}


				{(produitDb && (produitDb.optionsUnitesTravail !== undefined && produitDb.optionsUnitesTravail.length > 0)) &&
					<Grid item xs={12}>
						<Typography component="h4" sx={{ color: '#004afe', fontSize: { xs: 22, sm: 22, md: 28, lg: 28 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
							Les options disponibles avec cette intervention
						</Typography>
					</Grid>
				}

				{
					// Boucle sur la liste des unites de travail
					produitDb ? produitDb.optionsUnitesTravail.map(function(d, index) {
						return (
							<Grid key={index} item sx={{ pb: 2 }}>
								<CardOptionUniteTravail uniteTravail={d} val={commande[d.workUnitKey]} />
							</Grid>
						)
					}) : ''
				}

			</Grid>

			{!props.validation.isValid &&
				<Message props={{ type: 'error', message: props.validation.messageErreur, contact: props.validation.contact }} />
			}

			<CommandeRecap />

		</>
	);
}